import React from "react";
import { WHATSAPP_NUMBER } from "../lib/api";

export default function WhatsAppButton() {
  const msg = encodeURIComponent("Hello Ayame Salon! I'd like to enquire about your services.");
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 left-6 z-50 group"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat on WhatsApp"
    >
      <div className="bg-[#25D366] hover:bg-[#1da851] transition-all duration-300 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-luxe group-hover:scale-110">
        <i className="fa-brands fa-whatsapp text-2xl"></i>
      </div>
      <span className="absolute left-16 top-1/2 -translate-y-1/2 bg-[var(--primary)] text-white text-xs px-3 py-1.5 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
        Chat on WhatsApp
      </span>
    </a>
  );
}
